import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Platform} from '../classes/platform';
import {RealtimeService} from './realtime/realtime.service';
import {WebsocketService} from './websocket/websocket.service';
import {RealtimeType} from './realtime/realtime-type.enum';

@Injectable({
    providedIn: 'root'
})
export class PlatformService extends RealtimeService<Platform> {

    constructor(public apiService: ApiService, protected websocketService: WebsocketService) {
        super(websocketService, RealtimeType.platforms);
    }

    getPlatform(id: number) {
        return this.apiService.getCallData$<Platform>(`platforms/${id}`);
    }

    getPlatforms() {
        return this.apiService.getCallData$<Platform[]>('platforms');
    }

    savePlatform(platform: Platform) {
        return this.apiService.postCall$<Platform>('platforms', platform);
    }

    deletePlatform(platformId: number) {
        return this.apiService.deleteCall(`platforms/${platformId}`);
    }

    itemInDaterange(planning: Platform, fromDate: Date, toDate: Date) {
        return true;
    }
}
